import React from "react";

import CrewCapacities from "../shared/CrewCapacities";
import CrewName from "../shared/CrewName";
import Event from "../shared/Event";

const Crew = ({ active, crew, events, onCrewSelect }) => (
  <div className={`panel ${active ? "panel-primary" : "panel-default"}`}>
    <div className="panel-heading" onClick={() => onCrewSelect(crew)}>
      <CrewName crew={crew} />
    </div>
    <div className="panel-body">
      <CrewCapacities crew={crew} events={events} />
      {events.length ? (
        events.map((e) => <Event eventId={e.id} event={e} key={e.id} />)
      ) : (
        <blockquote>No jobs are scheduled for this crew</blockquote>
      )}
    </div>
  </div>
);

export default Crew;
